import React, { useEffect, useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import { useNavigate, useParams } from 'react-router-dom';
import HouseDetails from './HouseDetails';
import { Actions } from '../../../client/Actions';
import { Col, Dropdown } from 'react-bootstrap';
import DivBetween from '../../components/div/DivBetween';
import EditButton from '../../components/button/EditButton';
import LightButton from '../../components/button/LightButton';
import HouseCalendarButton from '../../components/lakeview/calendar/HouseCalendarButton';

const HouseDetailsPage = (props) => {
  const [house, setHouse] = useState();

  let { id } = useParams();
  const navigate = useNavigate();

  function loadHouse() {
    Actions.get('house/' + id, setHouse);
  }

  useEffect(() => {
    loadHouse();
  }, [id]);

  if (!house) {
    return <></>;
  }

  return (
    <>
      <CustomContainer
        key={id}
        title={
          <DivBetween>
            Domek
            <div className="d-none d-md-flex gap-2">
              <HouseCalendarButton houseId={id} />
              <LightButton onClick={() => navigate(`/house-offer/${id}`)}>
                Rezerwuj
              </LightButton>
              <EditButton onClick={() => navigate(`/house/${id}`)} />
            </div>

            {/* Mobile dropdown */}
            <div className="d-md-none">
              <Dropdown align="end">
                <Dropdown.Toggle variant="outline-primary" size="sm" id="dropdown-house-actions">
                  <i className="fas fa-ellipsis-h" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow-sm p-2">
                  <Dropdown.Item as="div">
                    <HouseCalendarButton houseId={id} />
                  </Dropdown.Item>
                  <Dropdown.Item as="div">
                    <LightButton onClick={() => navigate(`/house-offer/${id}`)}>
                      Rezerwuj
                    </LightButton>
                  </Dropdown.Item>
                  <Dropdown.Item as="div">
                    <EditButton onClick={() => navigate(`/house/${id}`)} />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </DivBetween>
        }

      >
        <Col md={8}>
          <HouseDetails house={house} />
        </Col>
      </CustomContainer>
    </>
  );
};

export default HouseDetailsPage;
